export default __webpack_public_path__ + "static/media/icon_free_dollar.2486bebb.svg";